import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import ProductBlock from 'pages/Product/ProductBlock';

import { T8y } from 'ui';

import style from '../description.module.scss';

const MAX_HEIGHT = 400;

const MobileDescription = ({ description }) => {
  const [maxHeight, setMaxHeight] = useState(`${MAX_HEIGHT}px`);
  const [isShowReadMore, setIsShowReadMore] = useState(false);

  const descriptionRef = useRef(null);

  const handleShowMoreClick = useCallback(() => {
    setMaxHeight('none');
    setIsShowReadMore(false);
  }, []);

  useLayoutEffect(() => {
    setIsShowReadMore(descriptionRef.current.clientHeight > MAX_HEIGHT);
  }, [description]);

  return (
    <ProductBlock title="Full Description">
      <T8y
        variant="t1v1"
        fullWidth
        className={style.productDescription}
        style={{ maxHeight }}
      >
        <div
          dangerouslySetInnerHTML={{ __html: description }}
          ref={descriptionRef}
        />
        <div />
      </T8y>
      {isShowReadMore && (
        <div className={style.readMore}>
          <T8y color="primary" pointer bold onClick={handleShowMoreClick}>
            Read more...
          </T8y>
        </div>
      )}
    </ProductBlock>
  );
};

export default MobileDescription;
